"use strict";

angular
	.module('rmContact')
    .factory('Contact', require('./contact.js'));